<div class="u-flex u-justifyCenter">
  <div class="DatagridNoData" data-test-id="datagridNoData">
    @if (noData) {
      <div>
        @if (noData.imageUrl) {
          <img
            [attr.alt]="noData?.message"
            [src]="noData.imageUrl"
            [style.width]="noData?.imageWidth"
          />
        }
        @if (noData.message) {
          <p
            class="ui-description"
            [innerHTML]="noData.message"
            data-test-id="datagridNoDataMessage"
          ></p>
        } @else {
          <ng-container *ngTemplateOutlet="defaultMessage"></ng-container>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="defaultMessage"></ng-container>
    }
    <ng-template #defaultMessage>
      <p class="ui-description" tabindex="0">No data found.</p>
    </ng-template>
  </div>
</div>
